<img [src]="visible && value && value.srcData ? value.srcData : './assets/images/videoadd.png'"   [height]="value.height" [width]="value.width">